function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M700.011 391.247c-2.65 115.855-52.517 229.196-161.545 287.428-169.681 97.917-379.041 27.027-490.438-122.82-72.106-189.11 86.078-415.314 253.47-498.674C546.472-48.496 704.94 175.725 700.01 391.247z",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

function Svg003(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 731 754",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzMxIDc1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNzAwLjAxMSAzOTEuMjQ3Yy0yLjY1IDExNS44NTUtNTIuNTE3IDIyOS4xOTYtMTYxLjU0NSAyODcuNDI4LTE2OS42ODEgOTcuOTE3LTM3OS4wNDEgMjcuMDI3LTQ5MC40MzgtMTIyLjgyLTcyLjEwNi0xODkuMTEgODYuMDc4LTQxNS4zMTQgMjUzLjQ3LTQ5OC42NzRDNTQ2LjQ3Mi00OC40OTYgNzA0Ljk0IDE3NS43MjUgNzAwLjAxIDM5MS4yNDdaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+Cjwvc3ZnPg==";
export { Svg003 as ReactComponent };